import client from "./client";
import type {
    ApplyCouponSuccess,
    RemoveCouponSuccess,
} from "./generated/contracts";

export async function applyCoupon(inputs: {
    coupon_code: string;
}): Promise<ApplyCouponSuccess> {
    const response = await client.post<ApplyCouponSuccess>(
        "/cart/coupon",
        inputs,
    );

    return response.data;
}

export async function removeCoupon(
    discountId: number,
): Promise<RemoveCouponSuccess> {
    const response = await client.post<RemoveCouponSuccess>(
        `/cart/coupon/${discountId}`,
    );

    return response.data;
}
